import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Table, Input, Form, Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";

import { TabPane, Tabs } from "pyxis-ui-kit";
import { AuthState } from "../../../../store/types";
import useWebSocket from "../../../../components/shared/hooks/useWebSocket";
import { WEBSOCKET_ENDPOINT } from "../../../../utilities/paths";
import CommentsTab from "../../../../components/DashboardSection/ActivityBar/CommentTab";

interface NoticeAdCommentsPropTypes {
    isCommentsDrawerOpen: boolean;
setIsCommentsDrawerOpen: Function
}

export const NoticeAdComments: FC<NoticeAdCommentsPropTypes> = ({isCommentsDrawerOpen, setIsCommentsDrawerOpen}) => {
  const { quoationApprovalFormData } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );
  const authState = useSelector(
    (state: { authentication: AuthState }) => state.authentication
  );

  const { token } = authState;

  const [selectedBanner, setSelectedBanner] = useState(-1);
  const [commentIndex, setCommentIndex] = useState(-1);
  const [replyCommentIndex, setReplyCommentIndex] = useState(-1);
  const [retainedComments, setRetainedComments] = useState([]);
  const [client, setClientActions] = useWebSocket(
    `${WEBSOCKET_ENDPOINT}/comment/${quoationApprovalFormData?.id}-amrequest?token=${token}`,
    true
  );
  const [inFocus, setInFocus] = useState(false);

  return (
    <Drawer
      placement="right"
      className="notice_request_drawer"
      width={350}
      onClose={() => setIsCommentsDrawerOpen(false)}
      visible={isCommentsDrawerOpen}
      title={null}
      closable={false}
    >
      {replyCommentIndex !== -1 ? (
        <>
          <Tabs activeKey="0" className="replies-tab">
            <TabPane
              tab={
                <span
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => setReplyCommentIndex(-1)}
                >
                  <span style={{ display: "flex", marginRight: "0.5rem" }}>
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 3L6 8L10 13"
                        stroke="#152370"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span>Comments</span>
                </span>
              }
              key="0"
            >
              <CommentsTab
                entityType="amrequest"
                setSelectedBanner={setSelectedBanner}
                selectedBanner={selectedBanner}
                commentIndex={commentIndex}
                setCommentIndex={setCommentIndex}
                replyCommentIndex={replyCommentIndex}
                setReplyCommentIndex={setReplyCommentIndex}
                retainedComments={retainedComments}
                client={client}
                setClientActions={setClientActions}
                setInFocus={setInFocus}
                id={String(quoationApprovalFormData?.id)}
                req_id={String(quoationApprovalFormData?.req_id)}
              />
            </TabPane>
          </Tabs>
        </>
      ) : (
        <CommentsTab
          entityType="amrequest"
          setSelectedBanner={setSelectedBanner}
          selectedBanner={selectedBanner}
          commentIndex={commentIndex}
          setCommentIndex={setCommentIndex}
          replyCommentIndex={replyCommentIndex}
          setReplyCommentIndex={setReplyCommentIndex}
          retainedComments={retainedComments}
          client={client}
          setClientActions={setClientActions}
          setInFocus={setInFocus}
          id={String(quoationApprovalFormData?.id)}
          req_id={String(quoationApprovalFormData?.req_id)}
        />
      )}
    </Drawer>
  );
};
